// @flow
import { PuntosActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    punto: {},
    listaPuntos: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false,
    filters: {}
};

type PuntosAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { punto?: {} | null, listaPuntos?: [] | null, loading?: boolean, +value ?: boolean };

const Puntos = (state: State = INIT_STATE, action: PuntosAction): any => {
    // console.log(action);
    switch (action.type) {
        case PuntosActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case PuntosActionTypes.GET_PUNTO: {
                    return {
                        ...state,
                        punto: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case PuntosActionTypes.LIST_PUNTOS: {
                    return {
                        ...state,
                        listaPuntos: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case PuntosActionTypes.ADD_PUNTO: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case PuntosActionTypes.UPDATE_PUNTO: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case PuntosActionTypes.DELETE_PUNTO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case PuntosActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case PuntosActionTypes.GET_PUNTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        punto: {},
                        loading: false,
                    };
                }
                case PuntosActionTypes.LIST_PUNTOS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaPuntos: [],
                        loading: false,
                    };
                }
                case PuntosActionTypes.ADD_PUNTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case PuntosActionTypes.UPDATE_PUNTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case PuntosActionTypes.DELETE_PUNTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case PuntosActionTypes.GET_PUNTO:
            return { ...state, error: false, loading: true };
        case PuntosActionTypes.LIST_PUNTOS:
            return { ...state, error: false, loading: true };
        case PuntosActionTypes.ADD_PUNTO:
            return { ...state, error: false, loadingForm: true };
        case PuntosActionTypes.UPDATE_PUNTO:
            return { ...state, error: false, loadingForm: true };
        case PuntosActionTypes.DELETE_PUNTO:
            return { ...state, error: false, loading: true };
        case PuntosActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                punto: {},
                listaPuntos: [],
                formSubmited: false
            };
        case PuntosActionTypes.SET_FILTER:
            return {
                ...state,
                filters: action.payload
            }
        default:
            return { ...state };
    }
};

export default Puntos;
